import {useState, useCallback} from 'react';

/**
 * Hook that maintains a sliding window of the most recent values and computes their average.
 *
 * @param {number} [windowSize=5] Number of recent values to average
 * @returns {[number, function]} Tuple containing current average and a function to add a new value
 */
const useSlidingWindowAverage = (windowSize = 5) => {
  const [values, setValues] = useState([]);
  const [average, setAverage] = useState();

  const addValue = useCallback((newValue) => {
    setValues((prevValues) => {
      // Add new value and keep only the last windowSize values
      const updatedValues = [...prevValues, newValue].slice(-windowSize);

      // Calculate new average
      const newAverage = updatedValues.reduce((sum, val) => sum + val, 0) / updatedValues.length;
      setAverage(newAverage);

      return updatedValues;
    });
  }, [windowSize]);

  return [average, addValue];
};

export default useSlidingWindowAverage;
